import "@babel/polyfill";
import 'core-js';
import 'raf/polyfill';

import React from "react";

import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import App from './App';
import PageTracker from '../components/PageTracker';
import { isLocalAdminEnabled } from '../utils/localhost';

import './styles.scss';

let AdminDashboard = null;

if (process.env.NODE_ENV === 'development') {
  AdminDashboard = require('../views/AdminDashboard').default;
}

function AppRouter() {
  const showAdmin = isLocalAdminEnabled() && AdminDashboard;

  return (
    <Router>
      <PageTracker />
      <Switch>
        {showAdmin && (
          <Route exact path="/admin" component={AdminDashboard} />
        )}
        <Route exact path="/" component={App} />
        <Redirect from="/home" to="/" />
        <Redirect from="/wishlist" to="/" />
        <Redirect from="/news" to="/" />
        <Redirect from="/news/:articleId" to="/" />
        <Redirect to="/" />
      </Switch>
    </Router>
  );
}

export default AppRouter;
